function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOfc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "orderFromChaos",
    width: 268.26,
    height: 56.2,
    viewBox: "0 0 70.976295 14.869584",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-83.019 -124.88)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ofcWelcomeInPieces",
    fill: "#000000",
    strokeWidth: "1px",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    },
    "aria-label": "welcome"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ofc-piece",
    transform: "matrix(.26458 0 0 .26458 83.019 124.88)",
    d: "m9.0742 42.73 1.2715-0.84766 1.2012 1.6621 1.1094-1.0156 1.8164 0.87305l-3.2539-12.662-1.6113-0.58984-0.74023 1.1074-1.4766-0.92187-1.5488 1.0215z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ofc-piece",
    transform: "matrix(.26458 0 0 .26458 83.019 124.88)",
    d: "m20.592 44.428-1.1934-0.14453-0.18359-1.3848-1.8477 1.1074-0.76758-1.1348-1.0645 3.5527h-0.28711l-0.77539-3.0215-1.8164-0.87305-1.1094 1.0156-1.2012-1.6621-1.2715 0.84766 3.0781 10.822h5.6152z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ofc-piece",
    transform: "matrix(.26458 0 0 .26458 83.019 124.88)",
    d: "m25.193 29.559-1.6387-1.4414-1.4766 1.6641-1.5801 0.08398-3.8984 13.006 0.76758 1.1348 1.8477-1.1074 0.18359 1.3848 1.1934 0.14453z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ofc-piece",
    transform: "matrix(.26458 0 0 .26458 83.019 124.88)",
    d: "m31.25 42.252 1.6348 0.55274 0.83203-1.7539 2.6328 1.5801-4.3379-14.352-1.0664 1.6855-2.0312-0.73828-1.3125 1.0332z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ofc-piece",
    transform: "matrix(.26458 0 0 .26458 83.019 124.88)",
    d: "m42.969 43.928-1.3086 0.63281-0.0918-1.4785-1.5703 0.92383-1.2051-1.5078-1.0098 3.9258h-0.28711l-1.1465-3.793-2.6328-1.5801-0.83203 1.7539-1.6348-0.55274 3.4375 11.301h5.5449z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ofc-piece",
    transform: "matrix(.26458 0 0 .26458 83.019 124.88)",
    d: "m41.705 31.162-2.9121 11.336 1.2051 1.5078 1.5703-0.92383 0.0918 1.4785 1.3086-0.63281 2.793-9.8262-0.77539-2.5664-0.83203 0.64648-0.18359-1.8457-1.4785 2.4004z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ofc-piece",
    transform: "matrix(.26458 0 0 .26458 83.019 124.88)",
    d: "m41.705 31.162 0.78711 1.5742 1.4785-2.4004 0.18359 1.8457 0.83203-0.64648 0.77539 2.5664 4.623-16.262h-5.2559z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ofc-piece",
    transform: "matrix(.26458 0 0 .26458 83.019 124.88)",
    d: "m27.602 30.26 1.3125-1.0332 2.0312 0.73828 1.0664-1.6855-3.1562-10.439h-4.752l-3.6055 12.025 1.5801-0.08398 1.4766-1.6641 1.6387 1.4414 0.99805-3.2227h0.2168z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ofc-piece",
    transform: "matrix(.26458 0 0 .26458 83.019 124.88)",
    d: "m5.8418 31.357 1.5488-1.0215 1.4766 0.92187 0.74023-1.1074 1.6113 0.58984-3.3145-12.9h-5.9043z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ofc-piece",
    transform: "matrix(.26458 0 0 .26458 83.019 124.88)",
    d: "m77.787 37.064 0.53125-1.3086-0.58789-1.4375 0.58789-0.71875-0.7793-0.92773h-14.209l-1.2773 1.0586 1.0449 1.4375-0.7832 1.1094 0.53516 0.78711z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ofc-piece",
    transform: "matrix(.26458 0 0 .26458 83.019 124.88)",
    d: "m77.984 25.359c1.03 1.7605 1.668 4.056 1.668 7.3125h-2.1133l0.7793 0.92773-0.58789 0.71875 0.58789 1.4375-0.53125 1.3086h7.627v-3.0957c0-4.6651-0.86859-8.3147-2.543-11.047l-0.56836 0.87891-1.5684-0.58789-0.6543 1.2422z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ofc-piece",
    transform: "matrix(.26458 0 0 .26458 83.019 124.88)",
    d: "m69.512 48.947-0.99219 1.4395 0.98047 1.0449-0.58789 0.98047 0.80274 1.5742c0.86836 0.0958 1.7187 0.21289 2.666 0.21289 5.76 0 9.8634-1.7985 12.023-3.3105v-4.1055c-3.24 1.512-6.4062 2.6641-11.158 2.6641-1.4026 0-2.5638-0.2541-3.7344-0.5z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ofc-piece",
    transform: "matrix(.26458 0 0 .26458 83.019 124.88)",
    d: "m56.102 41.125c1.4026 7.283 5.8579 12.006 13.613 12.861l-0.80274-1.5742 0.58789-0.98047-0.98047-1.0449 0.99219-1.4395c-4.1817-0.87846-6.8562-3.4315-7.8984-8.1445l-2.1738 0.63477-1.5664-0.7832z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ofc-piece",
    transform: "matrix(.26458 0 0 .26458 83.019 124.88)",
    d: "m56.102 41.125 1.7715-0.4707 1.5664 0.7832 2.1738-0.63477c-0.25349-1.1463-0.49112-2.3127-0.53711-3.7383h1.7734l-0.53516-0.78711 0.7832-1.1094-1.0449-1.4375 1.2773-1.0586h-2.2539c0.06365-0.93083 0.27185-1.6511 0.43164-2.4434l-1.6758 0.10547-0.7832-0.6543-1.7637 0.26172-1.0234-1.1055c-0.49536 1.8822-0.80078 3.971-0.80078 6.3555v1.0078c0 1.8124 0.33824 3.3556 0.64062 4.9258z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ofc-piece",
    transform: "matrix(.26458 0 0 .26458 83.019 124.88)",
    d: "m56.262 28.836 1.0234 1.1055 1.7637-0.26172 0.7832 0.6543 1.6758-0.10547c0.9178-4.5505 3.2282-7.0281 5.9707-8l0.25781-2.4766-2.8086 0.13086-0.44922-1.3027c-3.8097 1.6991-6.8502 5.0633-8.2168 10.256z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ofc-piece",
    transform: "matrix(.26458 0 0 .26458 83.019 124.88)",
    d: "m64.479 18.58 0.44922 1.3027 2.8086-0.13086-0.25781 2.4766c1.1013-0.39028 2.253-0.57227 3.3906-0.57227 3.3896 0 5.6857 1.2598 7.1152 3.7031l2.0957-0.9043 0.6543-1.2422 1.5684 0.58789 0.56836-0.87891c-2.3053-3.7616-6.1853-5.7305-11.857-5.7305-2.3021 0-4.5119 0.4863-6.5352 1.3887z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ofc-piece",
    transform: "matrix(.26458 0 0 .26458 83.019 124.88)",
    d: "m99.381 41.012-1.7402-1.0703-1.0156 1.4785-2.7871-0.58398v12.717h5.543z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ofc-piece",
    transform: "matrix(.26458 0 0 .26458 83.019 124.88)",
    d: "m99.381 27.898-1.3711 1.0508-1.1094-1.293-1.3848 1.6621-1.6777 0.5918v10.926l2.7871 0.58398 1.0156-1.4785 1.7402 1.0703z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ofc-piece",
    transform: "matrix(.26458 0 0 .26458 83.019 124.88)",
    d: "m97.178 16.57-2.123 0.92383-1.2168-0.53516v12.951l1.6777-0.5918 1.3848-1.6621 1.1094 1.293 1.3711-1.0508v-10.203z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ofc-piece",
    transform: "matrix(.26458 0 0 .26458 83.019 124.88)",
    d: "m93.838 16.959 1.2168 0.53516 2.123-0.92383 2.2031 1.125v-15.695h-5.543z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ofc-piece",
    transform: "matrix(.26458 0 0 .26458 83.019 124.88)",
    d: "m110.6 47.602c2.7765 4.3469 7.4789 6.5977 13.664 6.5977 4.968 0 8.1354-1.4386 10.439-2.8066v-4.4648c-1.8 1.008-4.967 2.5195-9.791 2.5195-4.3059 0-7.3536-1.3599-9.2305-4.1406l-3.9062-1.207 0.73828 2.8633z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ofc-piece",
    transform: "matrix(.26458 0 0 .26458 83.019 124.88)",
    d: "m110.6 47.602 1.9141-0.63867-0.73828-2.8633 3.9062 1.207c-1.4498-2.148-2.2188-5.1224-2.2188-9.1074v-1.7266c0-0.54973 0.10661-0.99774 0.14648-1.5098l-2.3887-1.9805-1.3848 0.83008-1.543-1.2188c-0.27412 1.4778-0.51758 2.9889-0.51758 4.7422v1.0801c0 4.6362 1.0111 8.347 2.8242 11.186z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ofc-piece",
    transform: "matrix(.26458 0 0 .26458 83.019 124.88)",
    d: "m108.29 30.594 1.543 1.2188 1.3848-0.83008 2.3887 1.9805c0.35374-4.5431 2.1562-7.6928 4.9707-9.4219l-0.89257-1.1504 0.55468-1.7559-1.6621-0.55274 0.0606-1.2012c-4.1979 1.9603-7.253 5.8115-8.3476 11.713z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ofc-piece",
    transform: "matrix(.26458 0 0 .26458 83.019 124.88)",
    d: "m116.64 18.881-0.0606 1.2012 1.6621 0.55274-0.55468 1.7559 0.89257 1.1504c1.6046-0.98578 3.416-1.6699 5.6113-1.6699 4.68 0 6.9844 0.86469 10.152 2.3047v-4.6074c-2.376-1.512-5.1833-2.377-9.8633-2.377-2.8486 0-5.4915 0.59285-7.8398 1.6895z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ofc-piece",
    transform: "matrix(.26458 0 0 .26458 83.019 124.88)",
    d: "m141.03 43.098 1.5645 0.03906 1.3066-1.1758 1.502 1.4375 1.3086-0.30078c-0.61423-1.7732-0.97656-3.9302-0.97656-6.6094v-1.8008c0-2.8167 0.60647-5.0349 1.4629-6.9668l-1.9258 0.32617-1.3711-1.3711-2.3379 0.4043c-0.91215 2.3698-1.4434 5.0873-1.4434 8.1836v1.0801c0 2.5098 0.34297 4.7378 0.91015 6.7539z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ofc-piece",
    transform: "matrix(.26458 0 0 .26458 83.019 124.88)",
    d: "m152.34 53.67-0.4082-1.2578 1.2422-0.39258-0.45899-1.1113 0.98047-0.45703-0.13867-1.1055c-3.0729-0.66967-5.5616-2.5353-6.8477-6.248l-1.3086 0.30078-1.502-1.4375-1.3066 1.1758-1.5645-0.03906c1.642 5.8366 5.6362 9.4173 11.312 10.572z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ofc-piece",
    transform: "matrix(.26458 0 0 .26458 83.019 124.88)",
    d: "m168.67 48.482-1.0625-2.6035-2.2871 1.1758-1.2168-0.76953c-1.8197 2.2173-4.4542 3.3789-7.7168 3.3789-0.99068 0-1.9297-0.12172-2.832-0.31836l0.13867 1.1055-0.98047 0.45703 0.45899 1.1113-1.2422 0.39258 0.4082 1.2578c1.2503 0.2544 2.4882 0.5293 3.9062 0.5293 5.2476 0 9.5468-2.0604 12.426-5.7168z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ofc-piece",
    transform: "matrix(.26458 0 0 .26458 83.019 124.88)",
    d: "m166.9 36.076v0.62695c0 4.1826-1.0024 7.3955-2.7969 9.582l1.2168 0.76953 2.2871-1.1758 1.0625 2.6035c2.3097-2.9334 3.683-6.9057 3.8008-11.785l-1.4668 1.4102-0.84961-2.7441-1.6992 0.98047z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ofc-piece",
    transform: "matrix(.26458 0 0 .26458 83.019 124.88)",
    d: "m166.9 36.076 1.5547 0.26758 1.6992-0.98047 0.84961 2.7441 1.4668-1.4102c5e-3 -0.22081 0.0449-0.416 0.0449-0.64062v-1.0078c0-4.3779-0.9736-7.9809-2.6934-10.814l-2.2812-0.17188-0.52149 1.7637-2.3027 0.06836c1.3492 2.0596 2.1836 4.9521 2.1836 9.0098z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ofc-piece",
    transform: "matrix(.26458 0 0 .26458 83.019 124.88)",
    d: "m164.72 25.895 2.3027-0.06836 0.52149-1.7637 2.2812 0.17188c-2.3812-3.9234-6.2367-6.3257-11.311-6.8574l0.0801 0.9375-1.502 1.0449 0.13086 1.2422-0.99414 1.1309c7e-3 -1e-5 0.011-0.0039 0.0176-0.0039 3.4503 0 6.5181 1.1823 8.4727 4.166z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ofc-piece",
    transform: "matrix(.26458 0 0 .26458 83.019 124.88)",
    d: "m141.56 27.08 2.3379-0.4043 1.3711 1.3711 1.9258-0.32617c1.6804-3.7907 4.7484-5.9821 9.0332-5.9883l0.99414-1.1309-0.13086-1.2422 1.502-1.0449-0.0801-0.9375c-0.7235-0.07581-1.4265-0.18555-2.1973-0.18555-7.0053 0-12.338 3.6069-14.756 9.8887z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ofc-piece",
    transform: "matrix(.26458 0 0 .26458 83.019 124.88)",
    d: "m222.79 35.99v17.562h5.4004v-19.967l-2.0527-0.10938-0.46289 2.0312-1.8477-0.55469z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ofc-piece",
    transform: "matrix(.26458 0 0 .26458 83.019 124.88)",
    d: "m222.79 35.99 1.0371-1.0371 1.8477 0.55469 0.46289-2.0312 2.0527 0.10938v-6.6738c0-5.2126-2.0546-8.083-5.7168-9.1836l0.42969 1.5215-2.0312 0.83203 1.4766 1.6621-1.7871 1.2305c1.5058 0.939 2.2285 2.5238 2.2285 5.0898z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ofc-piece",
    transform: "matrix(.26458 0 0 .26458 83.019 124.88)",
    d: "m220.56 22.975 1.7871-1.2305-1.4766-1.6621 2.0312-0.83203-0.42969-1.5215c-1.194-0.35882-2.5518-0.53711-4.0742-0.53711-3.1491 0-6.3518 1.0941-9.4707 2.6797l-0.34375 2.6113 0.92969 1.0898c2.3793-0.92378 4.6419-1.6289 6.7246-1.6289 1.9586 0 3.2931 0.38944 4.3223 1.0312z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ofc-piece",
    transform: "matrix(.26458 0 0 .26458 83.019 124.88)",
    d: "m201.76 38.715v14.838h5.4727v-11.279l-1.8867-2.5156-1.293 1.0156-1.1094-1.7559z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ofc-piece",
    transform: "matrix(.26458 0 0 .26458 83.019 124.88)",
    d: "m201.76 38.715 1.1836 0.30273 1.1094 1.7559 1.293-1.0156 1.8867 2.5156v-13.971l-1.332 0.64648-1.8477-0.64648-0.83203 1.0156-1.4609-0.35547z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ofc-piece",
    transform: "matrix(.26458 0 0 .26458 83.019 124.88)",
    d: "m201.76 28.963 1.4609 0.35547 0.83203-1.0156 1.8477 0.64648 1.332-0.64648v-1.3906c0-0.864-0.0724-1.513-0.2168-2.377 0.87412-0.39057 1.6636-0.64116 2.4922-0.96289l-0.92969-1.0898 0.34375-2.6113c-0.87438 0.44452-1.7737 0.72946-2.625 1.2812h-0.28906c-0.76626-1.2327-1.8221-2.1407-3.1055-2.7949l-0.88281 0.98438 0.64648 1.6641-1.6621 0.36914 1.7559 1.9395-1.7871 1.2168c0.47678 0.92483 0.78711 2.0245 0.78711 3.5332z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ofc-piece",
    transform: "matrix(.26458 0 0 .26458 83.019 124.88)",
    d: "m200.98 24.531 1.7871-1.2168-1.7559-1.9395 1.6621-0.36914-0.64648-1.6641 0.88281-0.98438c-1.4902-0.75966-3.2966-1.166-5.4629-1.166-4.032 0-7.8482 1.6561-11.16 3.7441h-0.17773l-2.0938 2.748 2.2227 0.84375c2.8745-1.3641 6.032-2.584 9.0488-2.584 3.0925 0 4.8049 0.86454 5.6934 2.5879z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ofc-piece",
    transform: "matrix(.26458 0 0 .26458 83.019 124.88)",
    d: "m180.74 41.379v12.174h5.4727v-10.346l-1.6484-1.6016-1.1992 1.1074-0.64843-2.125z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ofc-piece",
    transform: "matrix(.26458 0 0 .26458 83.019 124.88)",
    d: "m180.74 41.379 1.9766-0.79102 0.64843 2.125 1.1992-1.1074 1.6484 1.6016v-10.682l-2.2949-0.62109-1.293 1.1094-1.8848-0.44922z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ofc-piece",
    transform: "matrix(.26458 0 0 .26458 83.019 124.88)",
    d: "m180.74 32.564 1.8848 0.44922 1.293-1.1094 2.2949 0.62109v-7.9902c7e-3 -0.0032 0.0147-0.0046 0.0215-0.0078l-2.2227-0.84375 2.0938-2.748h-0.10938v-3.0957h-5.2559z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ofc-piece",
    transform: "matrix(.26458 0 0 .26458 83.019 124.88)",
    d: "m248.15 48.395-1.7637 0.75195 0.58789 1.959-1.959 0.26172-0.0977 1.1074c2.3208 1.0884 5.0543 1.7246 8.3106 1.7246 5.76 0 9.8634-1.7985 12.023-3.3105v-4.1055c-3.24 1.512-6.4062 2.6641-11.158 2.6641-2.3096 0-4.2695-0.36389-5.9434-1.0527z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ofc-piece",
    transform: "matrix(.26458 0 0 .26458 83.019 124.88)",
    d: "m242.03 37.064-2.3086-1.7656-1.4375 1.6973-1.2402-1.3711-0.71094 0.85938c0.0746 7.7648 2.971 13.359 8.582 15.99l0.0977-1.1074 1.959-0.26172-0.58789-1.959 1.7637-0.75195c-3.8573-1.5875-6.0257-5.1038-6.2266-11.33z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ofc-piece",
    transform: "matrix(.26458 0 0 .26458 83.019 124.88)",
    d: "m242.08 37.064 0.31641-2.6152-0.83789-0.41992-0.55469-0.69141 0.91406-0.66602c5e-5 -7.45e-4 -5e-5 -0.0012 0-2e-3 0.34786-5.0803 2.2808-7.864 4.6875-9.4121l-0.79687-0.86719 0.36914-1.4785-1.293-0.46094 0.36914-0.9707-1.0234-0.3418c-4.6209 2.5605-7.9277 7.7343-7.9277 16.053v1.0078c0 0.10247 0.0264 0.18344 0.0273 0.28516l0.71094-0.85938 1.2402 1.3711 1.4375-1.6973 2.3086 1.7656z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ofc-piece",
    transform: "matrix(.26458 0 0 .26458 83.019 124.88)",
    d: "m252.64 37.064-0.54492-1.2793 0.59961-0.59961-0.64649-1.1094-1.0625-0.46094 0.63477-0.94336h-9.6973l-0.91406 0.66602 0.55469 0.69141 0.83789 0.41992-0.31641 2.6152z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ofc-piece",
    transform: "matrix(.26458 0 0 .26458 83.019 124.88)",
    d: "m261.32 37.064 0.55859-1.1406-0.73828-0.59961 0.92383-1.5254-1.6113-1.127h-8.8398l-0.63477 0.94336 1.0625 0.46094 0.64649 1.1094-0.59961 0.59961 0.54492 1.2793z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ofc-piece",
    transform: "matrix(.26458 0 0 .26458 83.019 124.88)",
    d: "m263.02 21.859-1.6895-0.02344-0.23046 1.0625-1.8008-0.41602v1.2012l-1.1973 0.42773c1.5704 1.7741 2.3965 4.5371 2.3965 8.5605h-0.0391l1.6113 1.127-0.92383 1.5254 0.73828 0.59961-0.55859 1.1406h4.9336v-3.0957c0-5.2877-1.0818-9.3087-3.2402-12.109z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ofc-piece",
    transform: "matrix(.26458 0 0 .26458 83.019 124.88)",
    d: "m251.86 17.191c-2.7265 0-5.3266 0.67365-7.625 1.9473l1.0234 0.3418-0.36914 0.9707 1.293 0.46094-0.36914 1.4785 0.79687 0.86719c1.5832-1.0183 3.3343-1.6016 5.1055-1.6016 2.8144 0 4.922 0.8004 6.3867 2.4551l1.1973-0.42773v-1.2012l1.8008 0.41602 0.23046-1.0625 1.6895 0.02344c-2.3677-3.0722-6.0378-4.668-11.16-4.668z",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ofcWelcomeWhole",
    fill: "#0159a8",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    },
    "aria-label": "welcome"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m86.235 139.04h1.4859l2.2288-7.2009h0.05715l2.1908 7.2009h1.4668l2.686-9.4488h-1.3906l-1.9431 7.5628h-0.0762l-2.286-7.5628h-1.2573l-2.267 7.5628h-0.0762l-1.9431-7.5628h-1.5621z",
    fill: "#0159a8",
    strokeWidth: ".26458px",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.17 139.22c1.524 0 2.6098-0.47625 3.1814-0.8763v-1.0858c-0.85725 0.40005-1.6954 0.70485-2.9528 0.70485-2.0193 0-3.1433-0.9144-3.2195-3.2766h6.4389v-0.81915c0-2.9337-1.2192-4.4386-3.81-4.4386-2.1717 0-4.1148 1.4668-4.1148 4.7625v0.2667c0 2.9528 1.505 4.7625 4.4768 4.7625zm-0.40005-8.6106c1.543 0 2.3241 0.85725 2.3241 2.9146h-4.9149c0.1524-2.2288 1.4097-2.9146 2.5908-2.9146z",
    fill: "#0159a8",
    strokeWidth: ".26458px",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.85 139.04h1.4668v-13.64h-1.4668z",
    fill: "#0159a8",
    strokeWidth: ".26458px",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.9 139.22c1.3144 0 2.1526-0.381 2.7622-0.74295v-1.1811c-0.47625 0.2667-1.3144 0.66675-2.5908 0.66675-2.0193 0-3.029-1.0858-3.029-3.5052v-0.4572c0-2.1717 1.124-3.3338 2.8384-3.3338 1.2382 0 1.8478 0.2286 2.686 0.6096v-1.2192c-0.62865-0.40005-1.3716-0.62865-2.6098-0.62865-2.4384 0-4.4196 1.4478-4.4196 4.8006v0.28575c0 3.1052 1.6574 4.7054 4.3624 4.7054z",
    fill: "#0159a8",
    strokeWidth: ".26458px",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.36 139.22c2.5527 0 4.3053-1.7907 4.3053-4.8006v-0.2667c0-2.9908-1.6192-4.7244-4.2862-4.7244-2.5527 0-4.2862 1.7907-4.2862 4.7816v0.28575c0 3.0099 1.6002 4.7244 4.2672 4.7244zm0.0381-1.2002c-1.5812 0-2.8194-0.85725-2.8194-3.4862v-0.47625c0-2.2098 1.0668-3.429 2.7813-3.429 1.543 0 2.8194 0.85725 2.8194 3.4862v0.47625c0 2.2288-1.0668 3.429-2.7813 3.429z",
    fill: "#0159a8",
    strokeWidth: ".26458px",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130.84 139.04h1.4478v-7.6772c0.762-0.36195 1.6002-0.6858 2.4003-0.6858 1.2573 0 1.7145 0.47625 1.7145 1.6192v6.7437h1.4478v-7.0485c0-0.2286-0.019-0.40005-0.0572-0.62865 0.89535-0.40005 1.6954-0.6858 2.4384-0.6858 1.2764 0 1.7336 0.47625 1.7336 1.6192v6.7437h1.4288v-7.0485c0-1.8288-0.9525-2.5718-2.5908-2.5718-1.0668 0-2.1717 0.381-3.2004 1.0478h-0.0762c-0.43815-0.70485-1.2002-1.0478-2.267-1.0478s-2.0764 0.43815-2.9528 0.9906h-0.0762v-0.81915h-1.3906z",
    fill: "#0159a8",
    strokeWidth: ".26458px",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m150.02 139.22c1.524 0 2.6098-0.47625 3.1814-0.8763v-1.0858c-0.85725 0.40005-1.6954 0.70485-2.9528 0.70485-2.0193 0-3.1432-0.9144-3.2194-3.2766h6.4389v-0.81915c0-2.9337-1.2192-4.4386-3.81-4.4386-2.1717 0-4.1148 1.4668-4.1148 4.7625v0.2667c0 2.9528 1.505 4.7625 4.4768 4.7625zm-0.40005-8.6106c1.543 0 2.3241 0.85725 2.3241 2.9146h-4.9149c0.1524-2.2288 1.4097-2.9146 2.5908-2.9146z",
    fill: "#0159a8",
    strokeWidth: ".26458px",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfc);
export default __webpack_public_path__ + "static/media/ofc.6e254c89.svg";
export { ForwardRef as ReactComponent };